/*
 * @Author: Changjun changjun19920716@gmail.com
 * @Date: 2025-02-25 21:00:49
 * @LastEditors: Changjun changjun19920716@gmail.com
 * @LastEditTime: 2025-02-26 14:46:29
 * @FilePath: /link-we-chat-front/vue3-lw-pc/env.js
 * @Description:
 * Copyright (c) 2025 by ${Changjun}, All Rights Reserved.
 */
/**
 * 环境变量
 * 以下划线 '_' 开头的字段表示只在build命令打包时有效，勿在项目中使用
 */
export const envs = {
  development: {
    DOMAIN: 'https://wx.aixiaobin.com',
    DOMAIN_MOBILE: 'https://demo.linkwechat.net/mobile',
    BASE_URL: '/', // 路由基础路径
    BASE_API: 'https://wx.aixiaobin.com/api/',
    PRIVIEW_URL: 'https://demo.linkwechat.net/fileView/onlinePreview?url=', // kkfileview，素材预览服务地址
    _ISGZIP: true, // 是否开启gzip压缩
    _ISCDN: false // 是否开启cdn加速
  },
  test: {
    DOMAIN: 'https://demo.linkwechat.net',
    DOMAIN_MOBILE: 'https://demo.linkwechat.net/mobile',
    BASE_URL: '/', // 路由基础路径
    BASE_API: 'https://demo.linkwechat.net/linkwechat-api',
    PRIVIEW_URL: 'https://demo.linkwechat.net/fileView/onlinePreview?url=', // kkfileview，素材预览服务地址
    _ISGZIP: true,
    _ISCDN: false
  },
  production: {
    DOMAIN: 'https://wx.aixiaobin.com',
    DOMAIN_MOBILE: 'https://demo.linkwechat.net/mobile',
    BASE_URL: '/', // 路由基础路径
    BASE_API: 'https://wx.aixiaobin.com/api/',
    PRIVIEW_URL: 'https://demo.linkwechat.net/fileView/onlinePreview?url=', // kkfileview，素材预览服务地址
    _ISGZIP: true,
    _ISCDN: false
  }
}
let _env = {
  ENV: ''
}
if (process.env.NODE_ENV == 'development' || !globalThis.document) {
  // 本地开发和构建(vite)时使用
  _env = envs[process.env.VUE_APP_ENV]
  _env.ENV = process.env.VUE_APP_ENV
} else {
  // 打包后，根据访问域名动态判断环境
  let mode = Object.keys(envs).find((e) => envs[e].DOMAIN === window?.location.origin)
  _env = envs[mode]
  _env.ENV = mode // 前端系统环境模式 development，test，production
}
export const env = _env
// console.log(1, env)
// module.exports = env
